// KULLANILMIYOR (2026-11-03): Getir platformu artık yok. Uber, Getir'i Trendyol ile birlikte satın aldı;
// Getir siparişleri artık Trendyol üzerinden geliyor. Bu kod eski Getir entegrasyonuna aittir ve sunucuda
// çalışmıyor; yeni geliştirme yapmayın, yeni işlere (iş kuyruğu, bildirim kuyruğu vb.) Getir eklemeyin.
// Eski Getir siparişleri raporlarda okunabilsin diye kod ve tablolar silinmedi.

/**
 * Getir adisyon (müşteri fişi) ürün satırı üretici.
 *
 * Bu helper, hem `GetirOrderDetailModal` (manuel "Fiş Yazdır" butonu) hem de
 * `useKitchenPrintHandlers.handleReceiptPrint` (otomatik yazdırma) tarafından
 * kullanılır. Tek bir kaynak olması sayesinde ürün adları, adetler, opsiyonlar
 * (toppings/choices) ve müşteri notları **aynı şekilde** fişe basılır.
 *
 * Eski hook mapping'i `(item.price || 0) * (item.quantity || 1)` ile toplamı
 * yeniden hesaplıyor ve opsiyon fiyatlarını dahil etmiyordu; ayrıca subItems'a
 * yalnızca `optionName` koyup `+`/`(+price)` formatlamasını ve `it.note`'u
 * eksik bırakıyordu. Modal'daki zengin mantık (satır 388-399'da) 1:1 buraya
 * taşındı.
 */
import type { PackageReceiptItem } from '../components/PackageReceiptPrintService';

interface GetirOption {
  optionName?: string;
  name?: string;
  price?: number;
}

interface GetirReceiptItemLike {
  name?: string;
  quantity?: number;
  price?: number;
  totalPrice?: number;
  /** Backend bu alanda topping/option fiyatları dahil toplamı verir. */
  totalPriceWithOption?: number;
  options?: GetirOption[];
  note?: string;
}

interface GetirOrderLike {
  items?: GetirReceiptItemLike[];
}

/**
 * Getir sipariş objesinden adisyon fişi için `PackageReceiptItem[]` üretir.
 *
 * @param order Getir API'den dönen sipariş objesi (`getirApi /api/getir-orders/order/{id}`
 *   yanıtının `data` kısmı ya da modal'a prop olarak gelen `order`).
 */
export function buildGetirReceiptItems(order: GetirOrderLike): PackageReceiptItem[] {
  const items = order.items || [];
  return items.map((it) => {
    const subs: { name: string }[] = (it.options || []).map((opt) => {
      const optName = opt.optionName || opt.name || '';
      const optPrice = opt.price || 0;
      const priceStr = optPrice > 0 ? ` (+${optPrice.toFixed(2)})` : '';
      return { name: `+ ${optName}${priceStr}` };
    });

    if (it.note) {
      subs.push({ name: `Not: ${it.note}` });
    }

    const qty = it.quantity || 1;
    const unitPrice = it.price || 0;
    // Modal ile aynı: önce backend'in opsiyonlar dahil hesapladığı toplam,
    // yoksa ham totalPrice, o da yoksa unit * qty fallback.
    const totalPrice = it.totalPriceWithOption ?? it.totalPrice ?? unitPrice * qty;

    return {
      name: it.name || 'Ürün',
      quantity: qty,
      unitPrice,
      totalPrice,
      vatRate: 0,
      subItems: subs.length > 0 ? subs : undefined,
    };
  });
}
